import { toSnakeKeys } from 'keys-transform';

import {
  FETCH_STATE_NONE,
  FETCH_STATE_PENDING,
  FETCH_STATE_SUCCESS,
  FETCH_STATE_ERROR,
} from '~/config/constants';

const defaultState = () => ({
  resource: {},
  invoice_kinds: [],
  invoices: [],
  total_pages: 0,
  resourceFetchState: FETCH_STATE_NONE,
  downloadFetchState: FETCH_STATE_NONE,
});

const mutations = {
  getResourceStart(state) {
    state.resourceFetchState = FETCH_STATE_PENDING;
  },
  getResourceSuccess(state, action) {
    Object.assign(state, { resource: action.payload.data });
    state.resourceFetchState = FETCH_STATE_SUCCESS;
  },
  getFilterConfigSuccess(state, action) {
    Object.assign(state, {
      invoice_kinds: action.payload.data.invoice_kinds,
    });
  },
  getResourceError(state) {
    state.resourceFetchState = FETCH_STATE_ERROR;
  },
  requestDownloadStart(state) {
    state.downloadFetchState = FETCH_STATE_PENDING;
  },
  requestDownloadSuccess(state) {
    state.downloadFetchState = FETCH_STATE_SUCCESS;
  },
  requestDownloadError(state) {
    state.downloadFetchState = FETCH_STATE_ERROR;
  },
  resetState(state) {
    Object.assign(state, this.defaultState());
  },
};

const actions = {
  fetchFilterConfig: ({ commit, rootGetters }) => {
    commit(
      'api/fetch',
      {
        url: '/invoices/reports/filter_config',
        method: 'GET',
        headers: {
          ...rootGetters['auth/getHeaders'],
        },
        onSuccess: ['reports/getFilterConfigSuccess'],
      },
      { root: true },
    );
  },
  fetchData: (
    { commit, rootGetters },
    {
      period, from, to, clientId, invoiceKind, fetchInvoices,
    },
  ) => {
    commit(
      'api/fetch',
      {
        url: '/invoices/reports',
        method: 'POST',
        body: {
          reports: {
            period,
            from,
            to,
            contact_id: clientId,
            invoice_kind: invoiceKind,
          },
        },
        headers: {
          ...rootGetters['auth/getHeaders'],
        },
        onStart: ['reports/getResourceStart'],
        onSuccess: fetchInvoices
          ? ['reports/fetchInvoices', 'reports/getResourceSuccess']
          : ['reports/getResourceSuccess'],
        onError: [
          'reports/getResourceError',
          {
            type: 'flashMessages/addMessage',
            kind: 'error',
            key: 'getResourceError',
          },
        ],
      },
      { root: true },
    );
  },
  fetchInvoices: ({ dispatch }, action) => {
    const {
      from,
      to,
      invoice_kind: invoiceKind,
      period,
      contact_id: invoicesForContact,
    } = action.payload.meta.body.reports;

    dispatch(
      'invoices/searchInvoices',
      {
        from,
        to,
        invoiceKind,
        period,
        invoicesForContact,
      },
      { root: true },
    );
  },
  requestDownload: ({ commit, rootGetters }, params) => {
    commit(
      'api/fetch',
      {
        url: '/invoices/reports/download',
        method: 'POST',
        body: { reports: { ...toSnakeKeys(params) } },
        headers: {
          ...rootGetters['auth/getHeaders'],
        },
        onStart: ['reports/requestDownloadStart'],
        onSuccess: [
          'reports/requestDownloadSuccess',
          {
            type: 'flashMessages/addMessage',
            kind: 'success',
            key: 'downloadReportSuccess',
          },
        ],
        onError: [
          'reports/requestDownloadError',
          {
            type: 'flashMessages/addMessage',
            kind: 'error',
            key: 'downloadReportError',
          },
        ],
      },
      { root: true },
    );
  },

  getResourceStart({ commit }) {
    commit('getResourceStart');
  },
  getResourceSuccess({ commit }, payload) {
    commit('getResourceSuccess', payload);
  },
  getResourceError({ commit }, payload) {
    commit('getResourceError', payload);
  },
  requestDownloadStart({ commit }) {
    commit('requestDownloadStart');
  },
  requestDownloadSuccess({ commit }, payload) {
    commit('requestDownloadSuccess', payload);
  },
  requestDownloadError({ commit }, payload) {
    commit('requestDownloadError', payload);
  },
  getFilterConfigSuccess({ commit }, payload) {
    commit('getFilterConfigSuccess', payload);
  },
  resetState({ commit }) {
    commit('resetState');
  },
};

const getters = {
  isResourceLoaded(state) {
    return (
      state.resourceFetchState === FETCH_STATE_SUCCESS
    );
  },
  isDownloadSuccess(state) {
    return state.downloadFetchState === FETCH_STATE_SUCCESS;
  },
  isDownloadInProgress(state) {
    return state.downloadFetchState === FETCH_STATE_PENDING;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
